import { CssBaseline, Tooltip } from "@material-ui/core";
import MaterialTable from "material-table";
import LabelsContext from "../../../../../lang/LabelsContext";
import { dateTimeView } from "../../../../../utils/Utils";
import MailView from "../../../../system/mail-view/MailView";
import { tableIcons } from "../../../../system/material-table-utils/MaterialTableUtils";
import EmailLogService, { EmailLogServiceType } from "./EmailLogService";

export default function EmailLog() {
  const { Labels } = LabelsContext();

  const { emailLogList, selectedEmail, setSelectedEmail }: EmailLogServiceType = EmailLogService();

  return (
    <>
      <CssBaseline />
      <MaterialTable
        onRowClick={(event, rowData) => setSelectedEmail(rowData)}
        icons={tableIcons}
        columns={[
          {
            field: "Date",
            title: Labels.DATE,
            render: (rowData: any) => <div>{dateTimeView(rowData.timeSent)}</div>,
          },
          {
            field: "type",
            title: "Type",
          },
          {
            field: "mailTo",
            title: "To",
          },
          {
            field: "cc",
            title: "Cc",
          },
          {
            field: "subject",
            title: "Subject",
            cellStyle: { width: "25%" },
            render: (rowData: any) => (
              <Tooltip title={<h3>{rowData.subject}</h3>}>
                <span>{rowData.subject.length > 60 ? `${rowData.subject.substring(0, 60)}...` : rowData.subject}</span>
              </Tooltip>
            ),
          },
        ]}
        title={""}
        data={emailLogList}
        options={{
          actionsColumnIndex: -1,
          pageSize: 10,
        }}
      />
      <MailView mail={selectedEmail} onClose={() => setSelectedEmail(undefined)} />
    </>
  );
}
